/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentV2
 */
export interface DocumentV2 {
    /**
     * 
     * @type {string}
     * @memberof DocumentV2
     */
    documentUid?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentV2
     */
    documentName?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentV2
     */
    documentFormCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentV2
     */
    documentLanguages?: Array<string>;
    /**
     * last modification date
     * @type {Date}
     * @memberof DocumentV2
     */
    documentLastUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentV2
     */
    documentRedirectUrl?: string;
    /**
     * 
     * @type {DocumentV2DocumentStatusEnum}
     * @memberof DocumentV2
     */
    documentStatus?: DocumentV2DocumentStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentV2
     */
    canRedistribute?: boolean;
}


/**
 * @export
 */
export const DocumentV2DocumentStatusEnum = {
    YetToDistribute: 'YET_TO_DISTRIBUTE',
    Pending: 'PENDING',
    Received: 'RECEIVED',
    InValidation: 'IN_VALIDATION',
    Valid: 'VALID',
    Incomplete: 'INCOMPLETE',
    Expired: 'EXPIRED',
    Deleted: 'DELETED',
    Distributed: 'DISTRIBUTED',
    Withdrawn: 'WITHDRAWN'
} as const;
export type DocumentV2DocumentStatusEnum = typeof DocumentV2DocumentStatusEnum[keyof typeof DocumentV2DocumentStatusEnum];


/**
 * Check if a given object implements the DocumentV2 interface.
 */
export function instanceOfDocumentV2(value: object): value is DocumentV2 {
    return true;
}

export function DocumentV2FromJSON(json: any): DocumentV2 {
    return DocumentV2FromJSONTyped(json, false);
}

export function DocumentV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'documentUid': json['documentUid'] == null ? undefined : json['documentUid'],
        'documentName': json['documentName'] == null ? undefined : json['documentName'],
        'documentFormCode': json['documentFormCode'] == null ? undefined : json['documentFormCode'],
        'documentLanguages': json['documentLanguages'] == null ? undefined : json['documentLanguages'],
        'documentLastUpdated': json['documentLastUpdated'] == null ? undefined : (new Date(json['documentLastUpdated'])),
        'documentRedirectUrl': json['documentRedirectUrl'] == null ? undefined : json['documentRedirectUrl'],
        'documentStatus': json['documentStatus'] == null ? undefined : json['documentStatus'],
        'canRedistribute': json['canRedistribute'] == null ? undefined : json['canRedistribute'],
    };
}

export function DocumentV2ToJSON(json: any): DocumentV2 {
    return DocumentV2ToJSONTyped(json, false);
}

export function DocumentV2ToJSONTyped(value?: DocumentV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentUid': value['documentUid'],
        'documentName': value['documentName'],
        'documentFormCode': value['documentFormCode'],
        'documentLanguages': value['documentLanguages'],
        'documentLastUpdated': value['documentLastUpdated'] == null ? value['documentLastUpdated'] : value['documentLastUpdated'].toISOString(),
        'documentRedirectUrl': value['documentRedirectUrl'],
        'documentStatus': value['documentStatus'],
        'canRedistribute': value['canRedistribute'],
    };
}

